import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { getUser } from '../../actions/userAction';
import { updateData, newSimulation, exitSimulation, toggleTimelineActive } from '../../actions/dataAction';
import TelescopeSlider from './TelescopeSlider';
import 'rc-slider/assets/index.css';
import _ from 'lodash';
import Loading from '../Loading.js';

const RangeContainer = styled.div`
  width: calc(100% - 30px);
  margin: 0 auto;

   > div {
     padding-right: 3px;
     padding-left: 3px;
   }
`;

const SliderScaleLabel = styled.p`
   text-align:left;
   color: #fff;
   position: relative;
   left: 20px;
   top: -7px;
`;

class SlidersContainer extends Component {
  prepareData(inData) {
    if (_.isEmpty(inData)) {
      return {};
    };

    // APPLY MODS TO SLIDERS
    let data = inData.variableData.variables;

    let hasRelevanceData = false;

    data.forEach(function(d,i) {
      if (d.id==="total") {
        hasRelevanceData=true;
      }
    });

    // Add relevance slider
    if (!hasRelevanceData) {
      //const total = {id:'total',name:'Relevance', score:inData.variableData.score||0, target:(inData.variableData.targetScore||inData.variableData.target)||0};
      const total = {id:'total',name:'Relevance', score:inData.variableData.score||0, nscore:inData.variableData.nscore||0, target:(inData.variableData.targetScore||inData.variableData.target)||0};
      data.push(total);
    }

    const mods = [
      {type: 'inactive', items: ["place"] },
      {type: 'alignRight', items :[/*"preference", "total"*/]},
      {type: 'blockClick', items :["total"]},
      {type: 'blockSlider', items: ["total"]},
      //{type: 'extraOffset', items: ["preference","total"]},
      {type: 'showScale', items: ["total"]}
    ];

    for (var i=0;i<mods.length;i++) {
      for (var j = 0; j < data.length; j++) {
        if (mods[i].items.indexOf(data[j].id) > -1) {
          data[j][mods[i].type] = true;
        };
      };
    };

    //Check if no place
    let checkVars = [
      {"id":"price","name":"Price","inactive":true, "offset":0},
      {"id":"place","name":"Place","inactive":true, "offset": 2},
      {"id":"promotion","name":"Promotion","inactive":true, "offset": 3},
      {"id":"people","name":"People","inactive":true, "offset": 5},
    ];

    checkVars.forEach(v => {
      let dpExists = false;
      data.forEach(dp => {
        if (dp.id === v.id) {
          dpExists = true;
        }
      });
      if (!dpExists) {
        data.push(v);
      }
    })

    // ASSIGN POSITIONAL OFFSET ATTRIBUTES TO SLIDERS
    let offsetOrder = ["price","product","place","promotion","proposal","people","preference","total"];
    let disabled = (this.props.user && this.props.user.userProfile && this.props.user.userProfile.disabledParams) || [];

    for (var i=offsetOrder.length;i>=0; --i) {
      if (disabled.indexOf(offsetOrder[i]) > -1) {
        offsetOrder.splice(i, 1);
      }
    }

    for (var i=data.length;i>=0; --i) {
      if (data[i] && disabled.indexOf(data[i].id) > -1) {
        data.splice(i, 1);
      }
    }

    for (var i=0;i<data.length; i++) {
      let arr = offsetOrder;

      for (var j=0;j<arr.length;j++) {
        if (data[i].id === arr[j]) {
          data[i].offset = j;
        };
      };
    };

    return data;
  }

  sliderChange = (score, sliderValue, id) => {
    this.props.updateData({id: id, score: score, sliderValue: sliderValue, deltaScore: (sliderValue - score), active: true});
  }

  toggleSliderActive = (sliderValue, id, active) => {
    this.props.updateData({id: id, sliderValue: sliderValue, active: !active});
  }

  buildSliderTicks = function(min,max,stepsize, showScale) {
    let marks = {};
    let distance = min > 0 ? (max-min):(-min + max);
    let tickStyle={display:'block',width:'10px',height:'1px',background:'#fff',opacity:1};
    let tickStyle5={display:'block',width:'12px',height:'1px',background:'#fff',opacity:1};
    let tickStyle10={display:'block',width:'15px',height:'1px',background:'#fff',opacity:1};
    let tickStyle25={display:'block',width:'15px',height:'1px',background:'#fff',opacity:1};

    // Distribute 100 ticks evenly
    for (var i=0;i<101;i++) {
      const t = i%5===0 && i%10!==0 ? tickStyle5 : (i%10===0 ? tickStyle10:tickStyle);
      const val = min + i*(stepsize*((distance/stepsize)/100));
      marks[val] = {
        style: {},
        label: (showScale && i%25===0) ? (<div style={tickStyle25}><SliderScaleLabel className="small-font-size">{parseInt(val)}</SliderScaleLabel></div>):(<div style={t}></div>),
      };
    }

    return marks;
  }

  isValidNumber(number) {
    return typeof(number) === 'number' && !isNaN(number)
  }

  renderSliders(data) {
    var dataPoints = data || [];
    var sliders = [];
    var _this = this;
    const sliderMinVal = _this.props.data.variableMin || 0;
    const sliderMaxVal = _this.props.data.variableMax || 100;
    // Slider setup
    const sliderStepSize = 0.1;
    const sliderOffset = 12.5;
    const simulationParams = this.props.data.simulationParams;

    if (_.isEmpty(dataPoints)) {
      return [];
    };

    // Compensate so weights add up to 100
    let sum = 0;
    dataPoints.forEach(dp => {
      if (dp.id !== "total" && dp.weight) {
        sum += parseFloat(dp.weight);
      }
    });
    let factor = 100/sum;


    dataPoints.forEach(function(dp,i) {
      const showScale = (dp.id ==="total");
      const marks = _this.buildSliderTicks(sliderMinVal, sliderMaxVal, sliderStepSize, showScale);
      const score = _this.isValidNumber(dp.nscore) ? parseFloat(dp.nscore).toFixed(2):0;
      dp.score = dp.nscore;
      let scoreSliderValue = dp.score;

      dp.adjustedWeight = parseFloat(dp.weight * factor).toFixed(1);
      dp.active = simulationParams && simulationParams[dp.id] && simulationParams[dp.id].active;
      dp.sliderValue = parseFloat(simulationParams && simulationParams[dp.id] && simulationParams[dp.id].sliderValue ? simulationParams[dp.id].sliderValue : ((dp.score + dp.target) / 2)).toFixed(2);
      dp.generatedScore = parseFloat(simulationParams && simulationParams[dp.id] ? simulationParams[dp.id].generatedScore : null).toFixed(2);

      if (_this.props.data.simulationMode) {
        if (dp.active) {
          scoreSliderValue = dp.sliderValue;
        } else {
          if (!dp.generatedScore || isNaN(dp.generatedScore)) {
            scoreSliderValue = dp.score;
          } else {
            scoreSliderValue = dp.generatedScore;
          }
        }
      }

      scoreSliderValue = parseFloat(scoreSliderValue).toFixed(2);

      if (isNaN(scoreSliderValue)) {
       scoreSliderValue = parseFloat(dp.score).toFixed(2);
      };
      if (!dp.target) {
        dp.target = 0;
      }
      if (dp.target && dp.target.target) {
        dp.target = parseFloat(dp.target.target).toFixed(2);
      }
      if (!_this.isValidNumber(dp.score)) {
        dp.inactive = true;
      }

      let options = {
        showScale: showScale,
        marks: marks,
        scoreSliderValue: scoreSliderValue,
        score: score,
        dataPoints: dataPoints,
        sliderMinVal: sliderMinVal,
        sliderMaxVal: sliderMaxVal,
        sliderOffset: sliderOffset
      }

      sliders.push(
        <TelescopeSlider dp={dp} options={options} key={dp.id}/>
      );

    });
    return sliders;
  }
  render() {
    const { data } = this.props;

    if (!data || !data.variableData) {
      return <Loading fullHeight={true}/>;
    };
    return (
      <RangeContainer className="col-md-12 simulationSliders" style={{flex:'1'}} >
        {this.renderSliders(this.prepareData(data))}
      </RangeContainer>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps, { getUser, updateData, newSimulation, exitSimulation, toggleTimelineActive  })(SlidersContainer);



// WEBPACK FOOTER //
// ./src/components/dataViews/SlidersContainer.js